import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import {mapToObjectDDL} from "../../../../common/mapper";
import {ACTIVITY_TYPE} from "../../../../common/Constants";

class MasterLogistikMotorVarianModifying extends Component {
    handleSubmit = () => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    discontinueOptions = [
        {
            label: "YES",
            value: true,
        },
        {
            label: "NO",
            value: false,
        },
    ];

    render() {
        return (
            <SimpleModal
                title="Form Varian"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <SimpleInput
                                id="input_text_kode_varian"
                                name="kodeVariant"
                                label="Kode Varian"
                                mandatory
                                readOnly={this.props.activityType === ACTIVITY_TYPE.UPDATE}
                                errorMessage={this.props.errors.kodeVariant}
                                value={this.props.controls.kodeVariant.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_kode_unit_pabrik"
                                name="kodeUnitPabrik"
                                label="Kode Unit Pabrik"
                                mandatory
                                errorMessage={this.props.errors.kodeUnitPabrik}
                                value={this.props.controls.kodeUnitPabrik.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_nama_varian"
                                name="namaVariant"
                                label="Nama Varian"
                                mandatory
                                errorMessage={this.props.errors.namaVariant}
                                value={this.props.controls.namaVariant.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_kode_isi_silinder"
                                name="isiSilinder"
                                label="Isi Silinder"
                                box="onlyNumber"
                                mandatory
                                errorMessage={this.props.errors.isiSilinder}
                                value={this.props.controls.isiSilinder.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_digit_awal_nosin"
                                name="digitAwalNosin"
                                label="Digit Awal Nosin"
                                mandatory
                                errorMessage={this.props.errors.digitAwalNosin}
                                value={this.props.controls.digitAwalNosin.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_digit_awal_noka"
                                name="digitAwalNoka"
                                label="Digit Awal Noka"
                                mandatory
                                errorMessage={this.props.errors.digitAwalNoka}
                                value={this.props.controls.digitAwalNoka.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_nama_type"
                                box="search"
                                name="idType"
                                label="Nama Tipe"
                                mandatory
                                errorMessage={this.props.errors.idType}
                                options={this.props.dataTypeDDL}
                                value={
                                    this.props.controls && Object.keys(this.props.controls).length > 0
                                        ? {
                                            label: this.props.controls.idType.value.label,
                                            value: this.props.controls.idType.value.value
                                        }
                                        : undefined
                                }
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_discontinue"
                                box="search"
                                name="discontinue"
                                label="Discontinue"
                                mandatory
                                errorMessage={this.props.errors.discontinue}
                                options={this.discontinueOptions}
                                value={
                                    this.props.controls && Object.keys(this.props.controls).length > 0
                                        ? mapToObjectDDL(
                                            this.props.controls.discontinue.value.label,
                                            this.props.controls.discontinue.value.value,
                                        )
                                        : undefined
                                }
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <div style={{textAlign: "center"}}>
                                <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                            </div>
                    </ModalContainer>
                }
            />
        );
    }
}

export default withFormGroup(MasterLogistikMotorVarianModifying);